import { ParkingRecordListItem } from './parking-record-list-item';
import styles from './index.module.scss';
import type { ParkingRecordBill } from '@autopass-web/types';

interface ParkingRecordListProps {
  parkingRecordBills: ParkingRecordBill[];
  onItemClick: (plateNumber: string) => void;
}

export const ParkingRecordList = ({
  parkingRecordBills,
  onItemClick,
}: ParkingRecordListProps) => {
  return (
    <div className={styles['card-list']}>
      {parkingRecordBills.map((bill) => (
        <ParkingRecordListItem
          key={`${bill.id}_${bill.plate_number}_${bill.checked_in_at}`}
          parkingRecordBill={bill}
          onClick={() => onItemClick(bill.plate_number)}
        />
      ))}
    </div>
  );
};
